export default __webpack_public_path__ + "static/media/banner-words.86f243a9.svg";